module.exports = "pegasus_template/assets/themecapture1/webinar/106.png";